import HamburgerIcon from '../assets/icons/hamburger.svg';
import XIcon from '../assets/icons/x.svg'

import React from 'react';
import NavbarMenu from './NavbarMenu';
import Logo from './Logo';

const Navbar = ({ toggleNavMenu, navMenuOpen, theme }) => {
  return (
    <nav className={`
      bg-rondoblue
      z-20
      top-0
      sticky
    `}>
      <div className='
        content-center
        flex
        items-center
        justify-center
        h-20
        z-20
        justify-between
      '>
        <div className="
          flex
          h-12
          pl-4
        ">
          <a
            aria-label='Buy Crabs in a Bucket'
            className='
              w-40
              justify-self-start
            '
            href={theme === 'shrimpocalypse' ? 'https://shop.bluerondogames.com/collections/crabs-in-a-bucket-shrimpocalypse' : 'https://shop.bluerondogames.com/products/crabs-in-a-bucket-1'}
            target="_blank"
            rel="noreferrer"
          >
            <button className='
              w-full
              h-full
              border-2
              border-white
              rounded-lg
              text-white
              text-2xl
              hover:bg-rondoblue-light
              transition-colors
            '>
              BUY NOW
            </button>
          </a>
        </div>
        
        <Logo theme={theme} />

        <div className='
          flex
          justify-end
          pr-4
          w-40
        '>
          <button
            aria-controls='nav-menu'
            aria-expanded={navMenuOpen}
            aria-haspopup='true'
            aria-label='Toggle navigation menu'
            onClick={toggleNavMenu}
          >
            {navMenuOpen ?
              <XIcon className='
                h-12
                w-12
              '/>
            :
              <HamburgerIcon className='
                h-12
                w-12
              '/>
            }
          </button>
        </div>
      </div>
      <NavbarMenu
        navMenuOpen={navMenuOpen}
        toggleNavMenu={toggleNavMenu}
        theme={theme}
      />
    </nav>
  )
}

export default Navbar;
